<template>
  <div>
    <div v-if="showDropin" class="dropin">
      <Dropin />
    </div>
    <div class="ts-drop-target" :class="{ active }" v-if="showLabel">
      <p class="title">
        <slot name="title"> Drop your files to import them instantly in </slot>
      </p>
      <p v-if="label" class="label">{{ label }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropin {
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}

.ts-drop-target {
  background: #ebecf0;
  box-shadow: -8px -8px 16px 0 rgba(250, 251, 255, 0.8), 8px 8px 16px 0 rgba(166, 171, 189, 0.8);
  border-radius: 100px;
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: normal, soft-light, normal;
  background-image: linear-gradient(to bottom, #99ffd1, #99ffd1), linear-gradient(281deg, #000000 100%, #ffffff 0%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);
  box-sizing: border-box;
  background-color: #99ffd1;
  color: black;
  transition: box-shadow 0.3s ease-in-out;

  padding: 26px 64px;

  text-align: center;

  cursor: pointer;

  &.active,
  &:hover {
    box-shadow: -10px -10px 16px 0 #fafbff, 8px 8px 16px 0 #a6abbd;
  }

  .title {
    font-family: Roboto;
    font-size: 16px;
    font-weight: 500;
    color: #33373d;
  }

  .label {
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #000000;
  }
}
</style>

<script>
import Dropin from '@/components/Dropin.vue';

export default {
  components: {
    Dropin
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    showDropin: {
      type: Boolean,
      default: false
    }
  }
};
</script>
